import CommodityDetail from './commodity-detail'
export default CommodityDetail